import { css } from 'styled-components'

const transparentDarkButtonTemplate = () => css`
  background: transparent;
  color: var(--sl-fg-base);

  min-width: unset;
  height: auto;
  padding: 0.125rem 0.25rem;

  &:not(:disabled) {
    &:hover {
      color: var(--primary);
    }
  }

  &:disabled {
    color: var(--sl-fg-base-disabled);
    cursor: not-allowed;
  }
`

export default transparentDarkButtonTemplate
